// src/screens/UnauthorizedScreen.js
import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import Ionicons from '@react-native-vector-icons/ionicons/static';

const UnauthorizedScreen = () => {
    const navigation = useNavigation();

    return (
        <View style={styles.container}>
            <Ionicons name="lock-closed" size={64} color="#86BC25" />
            <Text style={styles.title}>Access Restricted</Text>
            <Text style={styles.subtitle}>
                You don't have permission to view this page.{'\n'}
                Please contact your administrator.
            </Text>
            <TouchableOpacity style={styles.button} onPress={() => navigation.goBack()}>
                <Ionicons name="arrow-back" size={18} color="#fff" style={{ marginRight: 8 }} />
                <Text style={styles.buttonText}>Go Back</Text>
            </TouchableOpacity>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
        padding: 32,
    },
    title: {
        fontSize: 22,
        fontWeight: '700',
        color: '#333',
        marginTop: 20,
        marginBottom: 10,
        fontFamily: 'PlusJakartaSans-Bold',
    },
    subtitle: {
        fontSize: 14,
        color: '#888',
        textAlign: 'center',
        lineHeight: 22,
        marginBottom: 32,
        fontFamily: 'PlusJakartaSans-Regular',
    },
    button: {
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: '#86BC25',
        paddingVertical: 12,
        paddingHorizontal: 24,
        borderRadius: 8,
    },
    buttonText: {
        color: '#fff',
        fontSize: 15,
        fontWeight: '600',
        fontFamily: 'PlusJakartaSans-SemiBold',
    },
});

export default UnauthorizedScreen;